import { getErrorMessage } from "@/shared/consts/error-codes"
import notify from "@/shared/lib/notify"
import { Modal } from "@/shared/ui/modal"
import { SubmitHandler, useForm } from "react-hook-form"
import { closeApproveApplicationModal, fetchApproveApplication, selectApproveJobApplicationModalOpen, selectOnApprove } from "../../model"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"

export const ApproveJobApplicationModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectApproveJobApplicationModalOpen)
    const onApprove = useAppSelector(selectOnApprove)

    const handleClose = () => {
        dispatch(closeApproveApplicationModal())
    }

    const onSubmit: SubmitHandler<{}> = async () => {
        await new Promise((res, rej) => {
        dispatch(fetchApproveApplication())
        .unwrap()
        .then(() => {
            notify.success('Заявка успешно принята')
            reset()
            onApprove?.()
            handleClose()
            res('')
        }).catch((e) => {
            notify.error(getErrorMessage(e))
            rej()
        })
    })
    }  

    const {
        handleSubmit,
        reset,
        formState: {
            isSubmitting
        }
    } = useForm()

    return (
        <Modal
            isOpen={isOpen}
            title="Изменение заявки"
            onRequestClose={handleClose}       
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <div>
                    Вы уверены, что хотите принять выбранную заявку?
                </div>
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Принять
                    </button>
                </div>
            </form>
        </Modal>
    )
}